import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Subject, takeUntil } from 'rxjs';

import {
  SelectionState,
  WordSelectionLookupService,
} from '../../services/word-selection-lookup.service';
import { WordClickService } from 'app/services/word-click.service';

@Component({
  selector: 'app-word-lookup-popover',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="state"
         class="fixed z-[9999] flex items-center gap-1.5 px-3 py-1.5
                bg-white dark:bg-gray-800 rounded-full shadow-lg
                border border-gray-200 dark:border-gray-600
                cursor-pointer select-none
                text-sm font-medium text-gray-700 dark:text-gray-200
                hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
         [style.left.px]="left"
         [style.top.px]="top"
         (mousedown)="$event.preventDefault(); $event.stopPropagation()"
         (click)="lookup()">
      <mat-icon class="icon-size-4 text-primary flex-shrink-0"
                svgIcon="heroicons_outline:book-open"></mat-icon>
      Clear Word
    </div>
  `,
})
export class WordLookupPopoverComponent implements OnInit, OnDestroy {

  state: SelectionState | null = null;
  left = 0;
  top  = 0;

  private _destroy$ = new Subject<void>();

  constructor(
    private _selectionService: WordSelectionLookupService,
    private _wordClickService: WordClickService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this._selectionService.selection$
      .pipe(takeUntil(this._destroy$))
      .subscribe(state => {
        this.state = state;
        if (state) {
          // Center the pill horizontally above the selection; clamp to viewport edges
          this.left = Math.max(4, state.rect.left + state.rect.width / 2 - 60);
          this.top  = Math.max(4, state.rect.top - 44);
        }
        this._cdr.markForCheck();
      });
  }

  lookup(): void {
    if (!this.state) return;
    this._wordClickService.setWord(this.state.text);
    this._selectionService.clear();
    window.getSelection()?.removeAllRanges();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
